export const buildApplicationHomeTasks = ({
  targetingComplete,
  primarySchool,
  completion = {},
} = {}) => {
  if (!targetingComplete) {
    return [
      {
        id: 'application-targeting',
        label: 'Choose your 3 school × program targets',
        path: '/home#targeting',
      },
    ];
  }

  return [
    {
      id: 'application-story',
      label: primarySchool
        ? `Write your story (${primarySchool})`
        : 'Write your story',
      path: '/applications',
      preCompleted: Boolean(completion.story),
    },
    {
      id: 'application-cv',
      label: 'Update CV',
      path: '/applications?kind=cv',
      preCompleted: Boolean(completion.cv),
    },
    {
      id: 'application-essays',
      label: primarySchool ? `Essay draft (${primarySchool})` : 'Essay draft',
      path: '/applications',
      preCompleted: Boolean(completion.essay),
    },
    {
      id: 'application-lor',
      label: 'Recommendation letter',
      path: '/applications',
      preCompleted: Boolean(completion.lor),
    },
    {
      id: 'application-funding',
      label: 'Build your funding mix',
      path: '/funding',
    },
  ];
};
